module.exports = __webpack_public_path__ + "media/images/delivery-man-c030f0f53a2573ba214bc3410d5e9a8b.png";